import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { AiOutlineDeploymentUnit, AiOutlineRise, AiOutlineSmile } from 'react-icons/ai';

const stats = [
  { value: 800000, suffix: '+', label: 'Deployments', icon: <AiOutlineDeploymentUnit className="text-4xl text-[#0077b6]" /> },
  { value: 99, suffix: '%', label: 'Reduction in Commercial Losses', icon: <AiOutlineRise className="text-4xl text-[#0077b6]" /> },
  { value: 95, suffix: '%', label: 'Customer Satisfaction', icon: <AiOutlineSmile className="text-4xl text-[#0077b6]" /> },
];

export default function CounterUp() {
  const { ref, inView } = useInView({ threshold: 0.3 });

  return (
    <div ref={ref} className="flex flex-wrap justify-center gap-8 p-8 items-center">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="w-72 p-8 text-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl shadow-xl transform transition duration-500 hover:scale-105 hover:bg-white/20"
        >
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 rounded-full p-4">
              {stat.icon}
            </div>
          </div>
          <h2 className="text-5xl font-bold text-white">
            {inView && <CountUp key={inView} end={stat.value} duration={3} suffix={stat.suffix} separator="," />}
          </h2>
          <hr className="border-white/30 my-3" />
          <p className="text-base text-white/90 font-medium">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}